import React from 'react';

const HeaderSkeleton = () => <div className="header-skeleton" />;

export default HeaderSkeleton;
